import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleQuote16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSpeechBubbleQuote16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 12v-1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9.013l-.286.26L6 13.74zm7 0H9.4l-2.727 2.48C6.03 15.062 5 14.607 5 13.74V12H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M7.274 5.5a.5.5 0 0 1-.457.525l-.028.006a.6.6 0 0 0-.153.067c-.122.074-.315.24-.465.625h.037A1.139 1.139 0 1 1 5.07 7.9l-.01-.058c-.061-.362-.056-.858.166-1.449.227-.604.57-.955.891-1.15a1.6 1.6 0 0 1 .553-.209l.048-.006.017-.001h.012c.001 0 .002 0 .028.498l-.026-.499a.5.5 0 0 1 .525.473m3.683 0a.5.5 0 0 1-.457.525l-.029.006a.6.6 0 0 0-.153.067c-.121.074-.315.24-.464.625h.037A1.139 1.139 0 1 1 8.753 7.9l-.011-.058c-.061-.362-.055-.858.167-1.449.227-.604.569-.955.89-1.15a1.6 1.6 0 0 1 .554-.209l.047-.006.018-.001h.012l.027.487-.026-.488a.5.5 0 0 1 .526.473"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleQuote16);
